import { useAuthStore } from "../state/auth";

export interface ScanReport {
    hospital_id: string;
    scans: any[];
}

export async function fetchReportScans(params: {
    start_date?: string;
    end_date?: string;
    location_id?: string;
    hospital_id?: string;
}): Promise<ScanReport> {
    const { user } = useAuthStore.getState();
    if (!user?.email) throw new Error("User not authenticated");

    const url = new URL("/api/reports/scans", window.location.origin);
    if (params.start_date) url.searchParams.append("start_date", params.start_date);
    if (params.end_date) url.searchParams.append("end_date", params.end_date);
    if (params.location_id) url.searchParams.append("location_id", params.location_id);
    if (params.hospital_id) url.searchParams.append("hospital_id", params.hospital_id);

    const headers: Record<string, string> = {
        "x-user-email": user.email,
        "x-api-key": import.meta.env.VITE_REPORTS_API_KEY || "",
    };
    const { token } = useAuthStore.getState();
    if (token) {
        headers["Authorization"] = `Bearer ${token}`;
    }

    const response = await fetch(url.toString(), { headers });

    if (!response.ok) {
        const error = await response.json();
        throw new Error(error.error || "Failed to fetch report scans");
    }

    return response.json();
}
